import { Store, Module, ActionContext, MutationTree } from 'vuex'
import {ListStateItem} from './list-state-item';
import ListData from './list-data';

export class ListModuleItem<T extends ListStateItem<U>, R, U> implements Module<ListStateItem<U>, R>{
    namespaced = true;
    state = {
        table: new ListData<U>()
    };
    mutations = {
        setCurrentPage(state: ListStateItem<U>, page: number) {
            state.table.currentPage = page;
        },
        setPageSize(state: ListStateItem<U>, pagesize: number) {
            state.table.pageSize = pagesize;
        },

        setPageData(state: ListStateItem<U>, payload:Map<any,any>){
            for(let [key, value] of payload){
                if(key != "table"){
                    state["table"][key] = value;
                }
            }
        }
    };
}